import React, { useRef, useEffect } from "react";
import Select from "react-select";
import { ReminderView, ViewOption } from "../../../../types/reminderTypes";
import styles from "./ViewSelector.module.scss";

const VIEW_OPTIONS: ViewOption[] = [
  {
    value: ReminderView.PATIENTS,
    label: "Lista po korisnicima",
    description: "Prikaz podsetnika grupisanih po pacijentima",
  },
  {
    value: ReminderView.ARTICLES,
    label: "Lista po artiklima",
    description: "Prikaz artikala grupisanih po podsetnicima",
  },
  {
    value: ReminderView.AGGREGATED,
    label: "Zbirni artikli",
    description: "Zbirni prikaz svih artikala sa ukupnim količinama",
  },
];

interface ViewSelectorProps {
  selectedView: ReminderView;
  onViewChange: (view: ReminderView) => void;
  loading?: boolean;
}

const ViewSelector: React.FC<ViewSelectorProps> = ({
  selectedView,
  onViewChange,
  loading = false,
}) => {
  // FIX: Use ref to prevent unnecessary change notifications
  const lastSelectedViewRef = useRef<ReminderView>(selectedView);

  const selectedOption = VIEW_OPTIONS.find(
    (option) => option.value === selectedView
  );

  // FIX: Only log when view actually changes
  useEffect(() => {
    if (lastSelectedViewRef.current !== selectedView) {
      console.log(
        "🟡 ViewSelector: selectedView changed from",
        lastSelectedViewRef.current,
        "to",
        selectedView
      );
      lastSelectedViewRef.current = selectedView;
    }
  }, [selectedView]);

  const handleChange = (option: ViewOption | null) => {
    if (option && option.value !== selectedView) {
      console.log(
        "🟡 ViewSelector: User changing view from",
        selectedView,
        "to",
        option.value
      );
      onViewChange(option.value);
    } else if (option) {
      console.log(
        "🟡 ViewSelector: Same view selected, ignoring:",
        option.value
      );
    }
  };

  const formatOptionLabel = (option: ViewOption) => (
    <div className={styles.optionLabel}>
      <div className={styles.optionTitle}>{option.label}</div>
      <div className={styles.optionDescription}>{option.description}</div>
    </div>
  );

  // FIX: Add key to force re-render when selectedView changes
  const selectKey = `view-selector-${selectedView}`;

  return (
    <div className={styles.viewSelector}>
      <Select
        key={selectKey}
        value={selectedOption}
        onChange={handleChange}
        options={VIEW_OPTIONS}
        formatOptionLabel={formatOptionLabel}
        className={styles.select}
        classNamePrefix="view-select"
        placeholder="Izaberite prikaz..."
        isSearchable={false}
        isLoading={loading}
        isDisabled={loading}
        menuPlacement="bottom"
        // FIX: Add these props to prevent focus issues
        blurInputOnSelect={true}
        closeMenuOnSelect={true}
        hideSelectedOptions={false}
      />
    </div>
  );
};

export default ViewSelector;
